import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import API_URL from "../config";
import "../styles/Formularios.css";
import { useApiFetch } from "../utils/apiFetch";
import InputSelectGenerico from "./InputSelectGenerico";
import InputSelectIp from "./InputSelectIp";

function AsignarServicios() {

    const { setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [idIp, setIdIp] = useState("");
    const [idServicio, setIdServicio] = useState("");
    const apiFetch = useApiFetch();
    const [verBoton, setVerBoton] = useState(false);

    const handleAsignarServicio = async (e) => {

        setVerBoton(false);

        if (!idServicio) {
            setError("\u274C Seleccione un servicio de la lista")
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        if (!idIp) {
            setError("\u274C Ingrese una ip válida")
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        try {

            const payload = {
                id_servicio: idServicio,
                id_ip: idIp
            }

            const data = await apiFetch("asignar_servicio.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Servicio asignado correctamente");
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setError("\u274C" + (data.message || "Error al asignar el servicio"));
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch (err) {
            setTimeout(() => setError("\u274C Error de conexión con el servidor"), 3000);
        }

    };

    useEffect(() => {
        if (idIp && idServicio) {
            setVerBoton(true);
        } else {
            setVerBoton(false);
        }

    }, [idIp, idServicio]);


    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}
            </>

            <form>

                <InputSelectGenerico
                    idSeleccionado={idServicio}
                    setIdSeleccionado={setIdServicio}
                    label="Servicio"
                    apiUrl={`consultar_servicios.php`}
                    valueField="id_servicio"
                    displayField="servicio"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un servicio"
                />

                <InputSelectIp
                    idIp={idIp}
                    setIdIp={setIdIp}
                    estadoFiltro=""
                    label="Asigne el servicio a una ip"
                />

                {verBoton && (
                    <div className="form-buttons">
                        <button type="button" onClick={handleAsignarServicio}>
                            Asignar Servicio
                        </button>
                    </div>
                )}

            </form>
        </div>
    );
}

export default AsignarServicios;